import {Fab, Link, List, ListItem, ListItemButton, ListItemText, Paper, TextField, Typography} from "@mui/material";
import SearchFloatButton from "./SearchFloatButton";
import {useEffect, useState} from "react";
import {AppPreset} from "../types/types";
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

interface NavBarPartyProps {
    presets: AppPreset[]
    onSearchTextChange?: (text: string) => void;
}

const NavBarParty: React.FC<NavBarPartyProps> = ({presets, onSearchTextChange}) => {
    const [openDrawer, setOpenDrawer] = useState<boolean>(false);
    const [searchText, setSearchText] = useState<string>("");

    const handleSearchTextChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setSearchText(e.target.value);
        if (onSearchTextChange) {
            onSearchTextChange(e.target.value);
        }
    }

    useEffect(() => {
        let element = document.getElementById("navByModule");
        const scrollEventHandler = () => {
            if (!element) {
                element = document.getElementById("navByModule");
            }
            if (!element) return;

            if (window.scrollY <= 90) {
                let a = window.scrollY;
                element.style.transform = `translateY(-${a}px)`;
                element.style.maxHeight = `calc(100vh - ${90 - a}px)`
            } else {
                element.style.transform = `translateY(-90px)`;
                element.style.maxHeight = `100vh`
                element.style.height = `100vh`;
            }
        };
        document.addEventListener("scroll", scrollEventHandler);

        return () => {
            document.removeEventListener("scroll", scrollEventHandler);
            localStorage.removeItem("scroll");
        }// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    if (!presets) return null;
    return <>
        <SearchFloatButton
            sx={{
                position: 'fixed',
                bottom: 25,
                left: `calc(100vw - ${presets.length > 1 ? 170 : 100}px)`,
            }}
        >
            <TextField value={searchText}
                       onChange={handleSearchTextChange}
                       label="Search" variant="outlined" size={"small"}
                       sx={{margin: "10px"}}
            />
        </SearchFloatButton>
        <Fab color="primary"
             sx={{
                 position: 'fixed',
                 bottom: 25,
                 left: "calc(100vw - 100px)",
             }}
             onClick={() => setOpenDrawer(!openDrawer)}>
            <FormatListBulletedIcon/>
        </Fab>
        <div style={{
            position: "fixed",
            top: "90px",
            left: 0,
            minWidth: "150px",
            maxWidth: "300px",
            width: "300px",
            transition: ".3s",
            transform: `translateX(${(openDrawer ? "0" : "-100%")})`,
            zIndex: 2
        }}>
            <Paper id={"navByModule"}
                   sx={{height: "calc(100vh - 90px);", overflow: "auto"}}
                   elevation={4}>
                {
                    <List sx={{paddingTop: 0}}>
                        <Typography variant="h6" gutterBottom
                                    style={{
                                        paddingLeft: "16px",
                                        fontWeight: "bold",
                                        paddingTop: "6px"
                                    }}>
                            Modules
                        </Typography>
                        {presets.map((preset, index) => {
                            if (!preset.items || preset.items.length === 0) return null;
                            return <ListItem key={`navByModule-${preset.id}-${index}`}
                                             disablePadding>
                                <Link href={`#${preset.id}-${preset.name}`}
                                      underline="none"
                                      sx={{width: "100%"}}>
                                    <ListItemButton>
                                        <ListItemText
                                            className={"listItemTextOneRow"}
                                            sx={{
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden"
                                            }}>
                                                                            <span style={{
                                                                                textOverflow: "ellipsis",
                                                                                whiteSpace: "nowrap",
                                                                                overflow: "hidden", color: "#036aaa"
                                                                            }}>
                                                                                {`${preset.name}`}
                                                                            </span>
                                        </ListItemText>
                                    </ListItemButton>
                                </Link>
                            </ListItem>
                        })}
                    </List>
                }
            </Paper>
        </div>
    </>
}

export default NavBarParty;